/**
 * Centralized community/external-links config.
 * Single source of truth for the Discord invite URL so it can never drift
 * out of sync across components.
 */
export const DISCORD_INVITE_URL = 'https://discord.gg/2285MefYzF';

/** Discord brand blurple, used for branded CTAs. */
export const DISCORD_BRAND_COLOR = 'hsl(235, 86%, 65%)';

/**
 * Fallback opener for triggers that are not real anchors (e.g. the command
 * palette). Real links should just use `<a href target="_blank">` — a native
 * anchor click escapes any embedding frame correctly, whereas script-driven
 * top-level navigation gets refused by the browser.
 */
export function openDiscordInvite() {
  const opened = window.open(DISCORD_INVITE_URL, '_blank', 'noopener,noreferrer');
  if (!opened) {
    // Popup blocked — fall back to a same-tab navigation.
    window.location.assign(DISCORD_INVITE_URL);
  }
}

